export default __webpack_public_path__ + "static/media/lock-icon.197a88fc.svg";